import { render, staticRenderFns } from "./Keybinds.vue?vue&type=template&id=dcce2000&"
import script from "./Keybinds.vue?vue&type=script&lang=ts&"
export * from "./Keybinds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports